export const DOMAIN_QUESTION_DETAILS = "QUESTION_DETAILS";
